export const labels = {
	'en': {
		pageTitle: 'My IASG',
	},
	'zh-hans': {
		pageTitle: '我的IASG',
	}
};
